export const GOOGLE_MAPS_API_KEY = 'AIzaSyD0CH7-cvnp8TfPYD_tSgoGv3SP2kCUWyQ'

export const GRACE_PERIOD_FULL_ACCESS_DAYS = 2 // Initial grace period with full access
export const GRACE_PERIOD_TOTAL_DAYS = 10 // Total grace period with restricted access

export const FREE_PRICE_LABEL = 'Free'

export const SUPPORT_EMAIL = 'support@bytebeam.io'

export const PERIOD_ABBREVIATIONS = {
	month: 'month',
	year: 'year',
} as const

export const URL_CHARACTER_LIMIT = 8000

export const TIMESERIES_DOWNLOAD_LIMIT_BYTES = 1 * 1024 * 1024 * 1024 // 1GB limit for timeseries CSV/XLSX exports

export const TIMESERIES_DOWNLOAD_ROW_LIMIT = 5_000_000 // Max rows allowed before a timeseries-download is blocked

export const SESSIONS_EXPORT_ROW_LIMIT = 5_000_000 // Max rows allowed before a sessions export is blocked

export const METADATA_UPLOAD_SIZE_WARNING_BYTES = 1 * 1024 * 1024 * 1024 // 1GB warning threshold for metadata CSV uploads

export const validationPatterns = {
	email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
	phone: /^\+?[\d\s-()]+$/,
	name: /^[a-zA-Z\s]+$/,
	alphanumeric: /^[a-zA-Z0-9]+$/,
	integer: /^-?\d+$/,
	wholeNumber: /^\d+$/,
	float: /^-?\d*\.?\d+$/,
}

// ====================== Documentation Pages Id ======================
export const urlToDocId = {
	// ========================= Device Management ===============================
	devices: '/platform-guide/device-management/introduction-to-device-management',

	// ========================= Dashboard ===============================
	dashboards: '/platform-guide/dashboards/introduction-to-dashboards',
	'compare-dashboards': '/platform-guide/dashboards/compare-dashboard#using-the-compare-dashboard-feature',

	// =========================  Actions ===============================
	actions: '/platform-guide/actions/action-details/introduction',
	'live-actions': '/platform-guide/actions/action-details/live-actions-list',
	inventory: '/platform-guide/actions/inventory-management/introduction',
	'firmware-files': '/platform-guide/actions/inventory-management/introduction',
	'json-configurations': '/platform-guide/actions/inventory-management/introduction',
	'geofence-configurations': '/platform-guide/actions/inventory-management/introduction',
	'new-action': '/platform-guide/actions/action-details/triggering-new-action',
	'action-settings': '/platform-guide/action-types/introduction-to-action-types',

	// ========================= Sessions ===============================
	alerts: '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'session-rules': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'alert-rules': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'alert-notification': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',

	// ========================= Settings ===============================
	general: '/platform-guide/general-settings',
	streams: '/platform-guide/streams-tables/introduction-to-streams',
	users: '/platform-guide/users/introduction-to-users-in-projects',
	roles: '/platform-guide/roles/role-based-access-control',
	metadata: '/platform-guide/metadata/introduction-to-metadata-keys',
	api_keys: '/platform-guide/api-keys/introduction-to-api-keys',
	session_types: '/platform-guide/session-types/introduction-to-session-types',
	dbc: '/platform-guide/dbc-parsers/introduction-to-dbc-parsers',
	device_components: '/platform-guide/device-components/introduction-to-device-components',
}

import baazBikesSvg from '@/assets/images/clients/baaz-bikes.svg'
import boschSvg from '@/assets/images/clients/bosch.svg'
import bullworkMobilitySvg from '@/assets/images/clients/bullwork-mobility.svg'
import ecozenSvg from '@/assets/images/clients/ecozen.svg'
import evageSvg from '@/assets/images/clients/evage.svg'
import exideSvg from '@/assets/images/clients/exide.svg'
import exponentSvg from '@/assets/images/clients/exponent.svg'
import invertedSvg from '@/assets/images/clients/inverted.svg'
import kptlSvg from '@/assets/images/clients/kptl.svg'
import lectrixSvg from '@/assets/images/clients/lectrix.svg'
import lohumSvg from '@/assets/images/clients/lohum.svg'
import matterSvg from '@/assets/images/clients/matter.svg'
import myTvsSvg from '@/assets/images/clients/my-tvs.svg'
import naarniSvg from '@/assets/images/clients/naarni.svg'
import numerosSvg from '@/assets/images/clients/numeros.svg'
import resyncSvg from '@/assets/images/clients/resync.svg'
import riverSvg from '@/assets/images/clients/river.svg'
import royalEnfieldSvg from '@/assets/images/clients/royal-enfield.svg'
import simpleEnergySvg from '@/assets/images/clients/simple-energy.svg'
import theEnergyCompanySvg from '@/assets/images/clients/the-energy-company.svg'
import torkSvg from '@/assets/images/clients/tork.svg'
import uplianceSvg from '@/assets/images/clients/upliance.svg'
import zyppElectricSvg from '@/assets/images/clients/zypp-electric.svg'

const CLIENT_WIDTH = 100
const CLIENT_HEIGHT = 48

export const clients = [
	{
		src: baazBikesSvg,
		alt: 'Baaz Bikes',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: boschSvg,
		alt: 'Bosch',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: bullworkMobilitySvg,
		alt: 'Bullwork Mobility',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: ecozenSvg,
		alt: 'Ecozen',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: evageSvg,
		alt: 'Evage',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: exideSvg,
		alt: 'Exide',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: exponentSvg,
		alt: 'Exponent',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: invertedSvg,
		alt: 'Inverted',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: kptlSvg,
		alt: 'KPTL',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: lectrixSvg,
		alt: 'Lectrix',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: lohumSvg,
		alt: 'Lohum',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: matterSvg,
		alt: 'Matter',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: myTvsSvg,
		alt: 'myTVS',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: naarniSvg,
		alt: 'NaArNi',
		width: CLIENT_WIDTH * 0.85,
		height: CLIENT_HEIGHT,
	},
	{
		src: numerosSvg,
		alt: 'Numeros',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: resyncSvg,
		alt: 'Resync',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: riverSvg,
		alt: 'River',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: royalEnfieldSvg,
		alt: 'Royal Enfield',
		width: CLIENT_WIDTH * 1.5,
		height: CLIENT_HEIGHT,
	},
	{
		src: simpleEnergySvg,
		alt: 'Simple Energy',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: theEnergyCompanySvg,
		alt: 'The Energy Company',
		width: CLIENT_WIDTH * 1.25,
		height: CLIENT_HEIGHT,
	},
	{
		src: torkSvg,
		alt: 'Tork',
		width: CLIENT_WIDTH,
		height: CLIENT_HEIGHT,
	},
	{
		src: uplianceSvg,
		alt: 'Upliance',
		width: CLIENT_WIDTH * 0.75,
		height: CLIENT_HEIGHT,
	},
	{
		src: zyppElectricSvg,
		alt: 'Zypp Electric',
		width: CLIENT_WIDTH * 2,
		height: CLIENT_HEIGHT,
	},
]
